<template>
	<div class="flex-column">
		<div class="full-height">
			<div>
				<label class="h6 display-block">
					현장명
					<input v-model="item.project_name" class="input-box radius-10 width-100 mt-10" placeholder="현장명을 입력하세요" maxlength="20" lang="ko"/>
				</label>

				<label class="h6 display-block mt-10">
					작업 기간

					<div class="justify-space-between gap-10 items-center mt-10">
						<input v-model="item.sDate" class="input-box radius-10  flex-1" placeholder="시작일 입력하세요" maxlength="20" lang="ko" type="date"/>
						~
						<input v-model="item.eDate" class="input-box radius-10  flex-1" placeholder="종료일 입력하세요" maxlength="20" lang="ko" type="date"/>
					</div>
				</label>

				<label class="h6 display-block mt-10">
					현장내용
				</label>


				<label class="display-block mt-10 input-box full-width radius-10">
					<v-icon
						class="color-icon"
					>mdi mdi-image</v-icon>
					{{ file_name }}
					<input
						v-show="false"
						type="file"
						placeholder="대표 이미지"
						class="input-box "
						maxlength="250"
						@change="setFile"
						accept="image/*, application/pdf"
					/>
				</label>

				<textarea
					v-model="item.project_content"
					class="input-box radius-10 width-100 mt-10"
					placeholder="현장내용 입력하세요"
					lang="ko">
				</textarea>
			</div>
		</div>
		<div
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="postProject"
			>등록</button>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'ProjectItem'
		, props: ['user']
		, data: function(){
			return {
				program: {
					name: '현장 등록'
					, not_top: true
					, title: true
					, bottom: false
					, is_container: true
				}
				, item: {

				}
			}
		}
		, computed: {
			file_name: function(){
				let t = '첨부파일을 선택하세요'

				if(this.item.b_file){
					t = this.item.b_file.name
				}

				return t
			}
		}
		, methods: {
			postProject: async function(){
				this.$bus.$emit('on', true)
				try {
					const result = await this.$request.init({
						method: 'post'
						, url: 'project/postProject'
						, data: this.item
					})

					if(result.success){
						this.$bus.$emit('notify', { type: 'success', message: result.message})
						this.$bus.$emit('to', { name: 'ProjectList'})
					}else{
						throw result.message
					}
				}catch (e){
					this.$bus.$emit('notify', { type: 'error', message: e})
				}finally {
					this.$bus.$emit('on', false)
				}
			}
			,setFile: function(e){
				let file = e.target.files[0]
				this.$set(this.item, 'b_file', file)
			}
		}
		, created() {
			this.$bus.$emit('onLoad', this.program)
		}
	}
</script>